// extracted by mini-css-extract-plugin
module.exports = {"root":"shop-page_root__9GZfF","content":"shop-page_content___f0lF","pagination":"shop-page_pagination__5GREH","cards":"shop-page_cards__YXrMi"};